// extracted by mini-css-extract-plugin
export const successWrapper = "dialog-module--successWrapper--3UvKD";
export const showOnce = "dialog-module--showOnce--1RG7C";
export const success = "dialog-module--success--323Bg";
export const zoomBig = "dialog-module--zoomBig--3I9Ea";
export const successMessage = "dialog-module--successMessage--1ZkD2";
export const zoomLittle = "dialog-module--zoomLittle--3mgz8";